import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const active = LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) || LANGUAGES[0];

  return (
    <div className="relative" data-testid="language-selector">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Change language"
        aria-expanded={open}
        className="flex items-center gap-1.5 rounded-lg border border-white/5 bg-white/[0.02] px-2.5 py-1.5 text-[12px] text-slate-300 hover:border-white/10"
      >
        <Globe size={13} strokeWidth={1.6} aria-hidden="true" />
        <span className="font-mono text-[10px]">{active.flag}</span>
        <ChevronDown size={12} aria-hidden="true" />
      </button>
      {open && (
        <div className="absolute right-0 z-40 mt-1 w-44 rounded-lg border border-white/10 bg-[#0f1730] p-1 shadow-2xl">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              data-testid={`lang-${l.code}`}
              className={`flex w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-left text-[12px] hover:bg-white/[0.04] ${
                active.code === l.code ? "text-white" : "text-slate-300"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="font-mono text-[10px] text-slate-500">{l.flag}</span>
                {l.label}
              </span>
              {active.code === l.code && <Check size={12} className="text-[#5B8DEF]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
